import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchRunners } from "./api";
import type { RunnerDisplayResponse } from "./api";

// Org-scoped запрос (см. `src/query/scope.ts`). Без polling: список
// раннеров не меняется в реальном времени как очередь задач —
// обновление идёт инвалидацией после регистрации, перевыпуска токена и
// снятия с учёта (`useRegisterRunner`, `useReissueRunnerToken`,
// `useRetireRunner`).
export function useRunners(): UseQueryResult<RunnerDisplayResponse[], Error> {
  return useOrgScopedQuery<RunnerDisplayResponse[]>({
    key: ["runners"],
    queryFn: () => fetchRunners(),
    retry: false,
  });
}
